import { useContext } from "react";
import { UserContext } from "../contexts/UserContext";
import { PERMISSIONS } from "../constants";

export const usePermissions = () => {
  const { user } = useContext(UserContext);

  const hasPermission = (permission) => {
    if (!user || !user.role) return false;

    const userPermissions = PERMISSIONS[user.role];
    return userPermissions ? userPermissions[permission] : false;
  };

  const canAccess = (requiredPermissions) => {
    if (!Array.isArray(requiredPermissions)) {
      return hasPermission(requiredPermissions);
    }

    return requiredPermissions.some((permission) => hasPermission(permission));
  };

  const getUserRole = () => {
    return user?.role;
  };

  const getUserMagasin = () => {
    return user?.magasin;
  };

  const isUserAssignedToStore = (storeId) => {
    return user?.magasin?.id === storeId;
  };

  return {
    hasPermission,
    canAccess,
    getUserRole,
    getUserMagasin,
    isUserAssignedToStore,
    userRole: user?.role,
    user,
  };
};
